"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-list-items-component"
  }, [_vm.list && _vm.list.length > 0 ? _c("div", [_c("div", {
    staticClass: "list-itens-informations"
  }, [_vm._m(0), _vm._v(" "), _vm._l(_vm.list, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "body",
      on: {
        click: function click($event) {
          return _vm.actionItem(item);
        }
      }
    }, [_c("div", {
      staticClass: "one"
    }, [item.logo ? _c("img", {
      attrs: {
        src: require("@/assets/images/logos/".concat(item.logo))
      }
    }) : _vm._e()]), _vm._v(" "), _c("div", {
      staticClass: "one"
    }, [_vm._v(_vm._s(item.Name))]), _vm._v(" "), _c("div", {
      staticClass: "two"
    }, [_vm._v(_vm._s(item.Sla || "--"))]), _vm._v(" "), _c("div", {
      staticClass: "three"
    }, [_vm._v(_vm._s(item.DigitalAssetType || "--"))]), _vm._v(" "), _c("div", {
      staticClass: "five"
    }, [item.Active ? _c("span", {
      staticClass: "status",
      class: {
        active: item.Active
      }
    }, [_vm._v(_vm._s(item.Active ? "Ative" : "Inativo"))]) : _vm._e()])]);
  })], 2)]) : _vm._e(), _vm._v(" "), !_vm.list || !_vm.list.length ? _c("div", [_c("h1", {
    staticClass: "empty-title"
  }, [_vm._v("\n      Sem dados no momento\n    ")])]) : _vm._e()]);
};
exports.render = render;
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "header"
  }, [_c("div", {
    staticClass: "one"
  }), _vm._v(" "), _c("div", {
    staticClass: "one"
  }, [_vm._v("Nome")]), _vm._v(" "), _c("div", {
    staticClass: "two"
  }, [_vm._v("Sla")]), _vm._v(" "), _c("div", {
    staticClass: "three"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c("div", {
    staticClass: "five"
  }, [_vm._v("Status")])]);
}];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;